module.exports = __webpack_public_path__ + "img/1724036013587-bolu.jpg.ef94d9dd.webp";